import React from 'react';

/**
 * Tiny inline trend line (pure SVG — no chart lib overhead for KPI cards).
 * Ported verbatim from D:\campaigning-system\src\components\charts\Sparkline.tsx.
 */
export function Sparkline({
  data,
  width = 96,
  height = 32,
  stroke = '#0A9188',
  fill = true,
  className = '',
}) {
  if (!data || data.length < 2) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = width / (data.length - 1);
  const pad = 3;
  const usableH = height - pad * 2;

  const points = data.map((d, i) => {
    const x = i * stepX;
    const y = pad + usableH - ((d - min) / range) * usableH;
    return [x, y];
  });

  const line = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const area = `${line} L${width},${height} L0,${height} Z`;
  const gid = `spark-${stroke.replace('#', '')}`;
  const [lastX, lastY] = points[points.length - 1];

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      preserveAspectRatio="none"
      aria-hidden
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={stroke} stopOpacity={0.22} />
          <stop offset="100%" stopColor={stroke} stopOpacity={0} />
        </linearGradient>
      </defs>
      {fill && <path d={area} fill={`url(#${gid})`} />}
      <path d={line} fill="none" stroke={stroke} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lastX} cy={lastY} r={2.6} fill={stroke} />
      <circle cx={lastX} cy={lastY} r={4.5} fill={stroke} opacity={0.18} />
    </svg>
  );
}

export default Sparkline;
